"use client"

import React from 'react'
import { useTranslations } from 'next-intl'
import { UIInput, type UIInputProps } from './ui-input'
import { cn } from '../../lib/utils'

export interface UIInputFilledProps extends Omit<UIInputProps, 'type' | 'placeholder'> {
  type?: 'email' | 'text' | 'password'
  placeholder?: string
}

/**
 * UIInputFilled - Filled Input Block
 * 배경색이 채워진 테두리 없는 입력 필드 컴포넌트입니다.
 * 배경색이 채워지고 테두리가 없는 입력 필드입니다.
 */
export const UIInputFilled = React.forwardRef<HTMLInputElement, UIInputFilledProps>(
  ({
    type = "email",
    placeholder,
    className,
    ...props
  }, ref) => {
    const t = useTranslations('components.forms')

    return (
      <UIInput
        ref={ref}
        type={type}
        placeholder={placeholder || t('input.email.placeholder')}
        className={cn(
          "bg-secondary border-none shadow-none max-w-xs",
          className
        )}
        {...props}
      />
    )
  }
)

UIInputFilled.displayName = "UIInputFilled"